import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

import { baseCss } from './css.js';
const nlIframeCss = baseCss;

const NlIframeStyle0 = nlIframeCss;

const NlConfirmLogout = /*@__PURE__*/ proxyCustomElement(class NlConfirmLogout extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlCloseModal = createEvent(this, "nlCloseModal", 7);
        this.titleModal = 'Confirm';
        this.description = 'Your profile keys are stored in this browser tab and will be deleted if you log out, and your profile will be inaccessible.';
        this.iframeUrl = '';
    }
    handleCancel() {
        this.nlCloseModal.emit();
    }
    render() {
        return (h("div", { key: '36ee9fd43bbb16768b7634783781ecffb1c9432a', class: "p-4 overflow-y-auto" }, h("div", { key: '1634e1fd37bc44030f22bfdab9f7deec2806731b', class: "mt-3 flex flex-col gap-2" }, this.iframeUrl && (h("iframe", { key: '2b1ab3032b152fb109f3531bb7600bb76aa1a562', src: this.iframeUrl, style: {
                width: '100%',
                height: '600px',
                border: '1px solid #ccc',
                borderRadius: '8px',
            } })))));
    }
    static get style() { return NlIframeStyle0; }
}, [0, "nl-iframe", {
        "titleModal": [1, "title-modal"],
        "description": [1],
        "iframeUrl": [1, "iframe-url"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-iframe"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-iframe":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlConfirmLogout);
            }
            break;
    } });
}
defineCustomElement();

export { NlConfirmLogout as N, defineCustomElement as d };

//# sourceMappingURL=nl-iframe2.js.map